import { c as _c } from "react/compiler-runtime";
import { CompanyAvatar } from "@components/common/company-avatar";
import { ChevronRightIcon, FontWeights, ListItem, ListItemButton, ListItemIcon, ListItemText, NO_TRANSLATE_CLASS, Skeleton } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { fetchingSdbCompanyFlagsSelector, selectedSdbCompanySelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { sidebarSelector } from "@store/ui/ui-selector";
import { withEllipsis } from "@styles/common-styles";
import { SidebarEvents, SidebarTabs } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { PALETTE_VARS } from "@styles/palette-vars";
// TODO: This component should not handle logics related to SdbCompanyMenu like isOpen or handleClick
// This should be fixed as part of: https://faro01.atlassian.net/browse/HBD-323
/**
 * Renders the item related to sdbCompanies (company/workspace) in the sidebar
 */
export function SdbCompanySidebarItem(t0) {
  const $ = _c(29);
  const {
    hasManySdbCompanies,
    isOpen,
    handleClick
  } = t0;
  const {
    isFullSize
  } = useAppSelector(sidebarSelector);
  const selectedCompany = useAppSelector(selectedSdbCompanySelector);
  const {
    trackEvent
  } = useTrackEvent();
  const {
    isFetchingSdbCompanies
  } = useAppSelector(fetchingSdbCompanyFlagsSelector);
  if (!selectedCompany && isFetchingSdbCompanies) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Skeleton variant="rectangular" sx={{
        width: "100%",
        height: "48px"
      }} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = isOpen ? `-3px 0 0 0 ${PALETTE_VARS.primary.main}` : "none";
  const t2 = isOpen ? "background.paper" : "surfaces.secondary";
  const t3 = hasManySdbCompanies ? "all" : "none";
  let t4;
  if ($[1] !== t1 || $[2] !== t2 || $[3] !== t3) {
    t4 = {
      display: "block",
      marginLeft: "3px",
      boxShadow: t1,
      backgroundColor: t2,
      pointerEvents: t3,
      paddingTop: "9px"
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = isOpen ? "workspaces-menu" : undefined;
  const t6 = isOpen ? "true" : undefined;
  let t7;
  if ($[5] !== handleClick || $[6] !== trackEvent) {
    t7 = ev => {
      trackEvent({
        name: SidebarEvents.openTab,
        props: {
          tab: SidebarTabs.workspace
        }
      });
      handleClick(ev);
    };
    $[5] = handleClick;
    $[6] = trackEvent;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = !hasManySdbCompanies;
  const t9 = isOpen ? "background.paper" : "surfaces.secondary";
  let t10;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      color: "text.primary",
      pointerEvents: "none",
      "& .MuiListItemIcon-root": {
        color: "action.active"
      }
    };
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== t9) {
    t11 = {
      minHeight: 48,
      justifyContent: "initial",
      px: 2.5,
      pl: 2.25,
      backgroundColor: t9,
      "&.Mui-disabled": t10
    };
    $[9] = t9;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      minWidth: 0,
      mr: 1,
      justifyContent: "center",
      alignItems: "center",
      height: "24px",
      width: "24px",
      fill: PALETTE_VARS.primary.main
    };
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const t13 = selectedCompany?.name ?? "";
  let t14;
  if ($[12] !== t13) {
    t14 = <ListItemIcon sx={t12}><CompanyAvatar name={t13} color={PALETTE_VARS.primary.main} size="large" /></ListItemIcon>;
    $[12] = t13;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== hasManySdbCompanies || $[15] !== isFullSize || $[16] !== selectedCompany?.name) {
    t15 = isFullSize && <Box component="div" sx={{
      display: "flex",
      alignItems: "center"
    }}><Box component="div" sx={{
        display: "flex",
        alignItems: "center"
      }}><ListItemText className={NO_TRANSLATE_CLASS} primary={<var>{selectedCompany?.name ?? ""}</var>} sx={{
          opacity: 1,
          fontSize: "14px",
          "& span": {
            ...withEllipsis,
            width: hasManySdbCompanies ? "135px" : "145px",
            fontSize: "14px",
            fontWeight: FontWeights.Bold
          }
        }} /></Box>{hasManySdbCompanies && <Box component="div" sx={{
        display: "flex",
        alignItems: "center"
      }}><ChevronRightIcon sx={{
          height: "16px",
          width: "16px"
        }} /></Box>}</Box>;
    $[14] = hasManySdbCompanies;
    $[15] = isFullSize;
    $[16] = selectedCompany?.name;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t11 || $[19] !== t14 || $[20] !== t15 || $[21] !== t8) {
    t16 = <ListItemButton selected={false} disabled={t8} disableRipple={true} sx={t11}>{t14}{t15}</ListItemButton>;
    $[18] = t11;
    $[19] = t14;
    $[20] = t15;
    $[21] = t8;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t16 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
    t17 = <ListItem disablePadding={true} sx={t4} data-testid="SIDEBAR_WORKSPACE_MAIN_BUTTON" aria-controls={t5} aria-haspopup="true" aria-expanded={t6} onClick={t7}>{t16}</ListItem>;
    $[23] = t16;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  return t17;
}